import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './index.css';

// Hardcoded fallback — Vite loadEnv wasn't picking up REACT_APP_GOOGLE_CLIENT_ID
// from .env.production during prod build, causing the provider to crash the
// entire admin app at runtime. This fallback guarantees a valid clientId always.
// v66.141 — defensive typeof process check so we never throw "process is not
// defined" when vite's process.env replacement misses (config not reloaded etc).
const GOOGLE_CLIENT_ID =
  import.meta.env.REACT_APP_GOOGLE_CLIENT_ID ||
  ((typeof process !== 'undefined' && process?.env?.REACT_APP_GOOGLE_CLIENT_ID) || null) ||
  '136621976144-087jkj242j2gh0baga7k3i1r6h20gvif.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
